/* eslint-disable */
import React from 'react'
import {Pagination} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import Loader from '../loaders/loader'

class Page extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false
    }
  }

  onChangePagination(pageNumber) {
    sessionStorage.setItem('pageNumber', pageNumber)
    let sortBy = sessionStorage.getItem('sortBy')
    let pageSize = sessionStorage.getItem('dropDownVal')
    const {url, urlParams} = this.props
    this.setState({
      loading: true
    })
    // alert(`${url}?export=false&${urlParams}&pageSize=${pageSize}&pageNumber=${pageNumber}`)
    http
      .get(`${url}?export=false&${urlParams}&pageSize=${pageSize}&pageNumber=${pageNumber}`, {})
      .then((response) => {
        this.setState({
          loading: false
        })
        if (response.data.error == null) {
          this.props.onResultFetched(response.data.object.result)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
        this.setState({
          loading: false
        })
      })
  }

  render() {
    const {total, url, urlParams} = this.props

    return (
      <div>
        <Loader show={this.state.loading} />
        <Pagination
          total={total}
          showQuickJumper
          current={Number(sessionStorage.getItem('pageNumber'))}
          pageSize={Number(sessionStorage.getItem('dropDownVal'))}
          urlParams={urlParams}
          url={url}
          onChange={this.onChangePagination.bind(this)}
        />
        <br />
        <p className="small font-weight-bold">{'تعداد ' + this.props.total + '  سطر یافت شد.'}</p>
      </div>
    )
  }
}

export default Page
